$(document).ready(function(){
  if($('.gen-me-page .featured-promotions__block.one-fourth').length > 0){
    $('.gen-me-page .featured-promotions__block.one-fourth').matchHeight();
  }
  if($('body.page-gen-me .featured-promotions__wrapper.gen-me-page.redeem.container .featured-promotions__block').length > 0){
     $('body.page-gen-me .featured-promotions__wrapper.gen-me-page.redeem.container .featured-promotions__block').matchHeight();
  }
});
$(window).ready(function() {
  $('body.page-gen-me .list-slider').addClass('owl-carousel');
  $('body.page-gen-me .list-slider').owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      margin: 13,
      items: 3,
      responsive:{
        0:{
          items: 1,
          margin: 13,
          loop: true
        },
        767:{
          items:1
        },
        1024:{
            items:2
        }
      }
    });
});